import axios from 'axios';
import Vue from 'vue'
import router from '../router.js';
import urls from './url.js';
import qs from 'qs'
const vue = new Vue()
axios.defaults.headers['Content-Type'] = "application/json;charset=UTF-8";
let myPost = axios.create({
    baseURL: urls.baseUrl,
    method: 'post',
})
let myCrudPost = axios.create({
    baseURL: urls.crudbaseUrl,
    method: 'post',
})
let myGet = axios.create({
    baseURL: urls.baseUrl,
    method: 'get',
})
let myCrudGet = axios.create({
    baseURL: urls.crudbaseUrl,
    method: 'get',
})
let myDelete = axios.create({
    baseURL: urls.baseUrl,
    method: 'delete',
})
let myPut = axios.create({
    baseURL: urls.baseUrl,
    method: 'put',
})

let myPost2= axios.create({
    baseURL: urls.baseUrl,
    method: 'post',
    headers: {'Content-Type': 'multipart/form-data'},
})

myPut.interceptors.request.use(config => {
    if (sessionStorage.getItem("token")) {
        config.headers = {
            'token': sessionStorage.getItem("token"),
            // 'Authorization': `Bearer ${sessionStorage.getItem("token")}`,
        }
    }
    return config;
}, error => {
    console.log(error);
    return Promise.reject();
})
myDelete.interceptors.request.use(config => {
    if (sessionStorage.getItem("token")) {
        config.headers = {
            'token': sessionStorage.getItem("token"),
            // 'Authorization': `Bearer ${sessionStorage.getItem("token")}`,
            // 'Access-Control-Allow-Origin': '*',
            // "access-control-allow-credentials": "true"
        }
    }
    return config;
}, error => {
    console.log(error);
    return Promise.reject();
})
myPost.interceptors.request.use(config => {
    config.headers = {
        'content-type': 'application/x-www-form-urlencoded; charset=UTF-8',
    }
    if (sessionStorage.getItem("token")) {
        // config.headers = {
        //     'token': sessionStorage.getItem("token"),
        // }
        config.headers.token = sessionStorage.getItem("token")
    }
    return config;
}, error => {
    console.log(error);
    return Promise.reject();
})

myGet.interceptors.request.use(config => {
    config.headers = {
        'content-type': 'application/x-www-form-urlencoded; charset=UTF-8',
    }
    if (sessionStorage.getItem("token")) {
        // config.headers = {
        //     'token': sessionStorage.getItem("token"),
        // }
        config.headers.token = sessionStorage.getItem("token")
    }
    return config;
}, error => {
    console.log(error);
    return Promise.reject();
})
myPost.interceptors.response.use(response => {
    // console.log(response)
    if (response.status === 200) {
        return response.data
    }
    // if (response.status === 200 && response.data.code == '200') {
    //     vue.$message({
    //         message: response.data.msg,
    //         type: "success",
    //     });
    //     return response.data;
    // }
    else {
        vue.$message.error(response.data.info);
        Promise.reject();
    }
}, error => {
    //错误跳转
    console.log(error)
    if (error.response.status === 500) {
        console.log(vue)
        if (error.response.data.info != '参数错误') {
            vue.$message.error(error.response.data.info);
        }
    } else if (error.response.status === 401) {
        sessionStorage.setItem("isLogin", false);
        console.log(sessionStorage.getItem("isLogin"));
        router.push({
            path: "/"
        })
        router.go(0)
        return Promise.reject();
    } else if (error.response.status === 404) {
        vue.$alert('页面不存在', '404错误', {
            confirmButtonText: '确定',
        });
        return Promise.reject();
    } else if (error.response.status === 402) {
        vue.$alert('请求次数限制', '402错误', {
            confirmButtonText: '确定',
        });
        return Promise.reject();
    } else {
        if (error.response.data.info != '参数错误') {
            vue.$message.error(error.response.data.info);
        }
    }
})
myGet.interceptors.response.use(response => {
    if (response.status === 200) {
        return response.data
    }
    // if (response.status === 200 && response.data.code == '200') {
    //     vue.$message({
    //         message: response.data.msg,
    //         type: "success",
    //     });
    //     return response.data;
    // }
    else {
        vue.$message.error(response.data.info);
        Promise.reject();
    }
}, error => {
    //错误跳转
    console.log(error);
    if (error.response.status === 500) {
        if (error.response.data.info != '参数错误') {
            vue.$message.error(error.response.data.info);
        }
    } else if (error.response.status === 401) {
        sessionStorage.setItem("isLogin", false);
        console.log(sessionStorage.getItem("isLogin"));
        router.push({
            path: "/"
        })
        router.go(0)
        return Promise.reject();
    } else if (error.response.status === 404) {
        vue.$alert('页面不存在', '404错误', {
            confirmButtonText: '确定',
        });
        return Promise.reject();
    } else if (error.response.status === 402) {
        vue.$alert('请求次数限制', '402错误', {
            confirmButtonText: '确定',
        });
        return Promise.reject();
    } else {
        if (error.response.data.info != '参数错误') {
            vue.$message.error(error.response.data.info);
        }
    }
})
myPut.interceptors.response.use(response => {
    // console.log(response)
    if (response.status === 200) {
        return response.data
    }
    // if (response.status === 200 && response.data.code == '200') {
    //     vue.$message({
    //         message: response.data.msg,
    //         type: "success",
    //     });
    //     return response.data;
    // }
    else {
        vue.$message.error(response.data.info);
        Promise.reject();
    }
}, error => {
    //错误跳转
    console.log(error)
    if (error.response.status === 500) {
        console.log(vue)
        if (error.response.data.info != '参数错误') {
            vue.$message.error(error.response.data.info);
        }
    } else if (error.response.status === 401) {
        sessionStorage.setItem("isLogin", false);
        console.log(sessionStorage.getItem("isLogin"));
        router.push({
            path: "/"
        })
        router.go(0)
        return Promise.reject();
    } else if (error.response.status === 404) {
        vue.$alert('页面不存在', '404错误', {
            confirmButtonText: '确定',
        });
        return Promise.reject();
    } else if (error.response.status === 402) {
        vue.$alert('请求次数限制', '402错误', {
            confirmButtonText: '确定',
        });
        return Promise.reject();
    } else {
        if (error.response.data.info != '参数错误') {
            vue.$message.error(error.response.data.info);
        }
    }
})
myDelete.interceptors.response.use(response => {
    // console.log(response)
    if (response.status === 200) {
        return response.data
    }
    // if (response.status === 200 && response.data.code == '200') {
    //     vue.$message({
    //         message: response.data.msg,
    //         type: "success",
    //     });
    //     return response.data;
    // }
    else {
        vue.$message.error(response.data.info);
        Promise.reject();
    }
}, error => {
    //错误跳转
    console.log(error)
    if (error.response.status === 500) {
        console.log(vue)
        if (error.response.data.info != '参数错误') {
            vue.$message.error(error.response.data.info);
        }
    } else if (error.response.status === 401) {
        sessionStorage.setItem("isLogin", false);
        console.log(sessionStorage.getItem("isLogin"));
        router.push({
            path: "/"
        })
        router.go(0)
        return Promise.reject();
    } else if (error.response.status === 404) {
        vue.$alert('页面不存在', '404错误', {
            confirmButtonText: '确定',
        });
        return Promise.reject();
    } else if (error.response.status === 402) {
        vue.$alert('请求次数限制', '402错误', {
            confirmButtonText: '确定',
        });
        return Promise.reject();
    } else {
        if (error.response.data.info != '参数错误') {
            vue.$message.error(error.response.data.info);
        }
    }
})

export default {
    login(obj) {
        obj = qs.stringify(obj)
        return myPost({
            url: urls.login,
            data: obj
        })
    },
    user_list(obj) {
        return myGet({
            url: `${urls.user_list}`,
            params: {
                ...obj
            }
        })
    },
    foreignlanguagecategorylist(obj) {
        obj = qs.stringify(obj)
        return myPost({
            url: urls.foreignlanguagecategorylist,
            data: obj
        })
    },
    add_foreignlanguagecategory(obj) {
        obj = qs.stringify(obj)
        return myPost({
            url: urls.add_foreignlanguagecategory,
            data: obj
        })
    },
    edit_foreignlanguagecategory(obj) {
        obj = qs.stringify(obj)
        return myPost({
            url: urls.edit_foreignlanguagecategory,
            data: obj
        })
    },
    del_foreignlanguagecategory(obj) {
        obj = qs.stringify(obj)
        return myPost({
            url: urls.del_foreignlanguagecategory,
            data: obj
        })
    },
    citylist(obj) {
        obj = qs.stringify(obj)
        return myPost({
            url: urls.citylist,
            data: obj
        })
    },
    industrylist(obj) {
        obj = qs.stringify(obj)
        return myPost({
            url: urls.industrylist,
            data: obj
        })
    },
    add_city(obj) {
        obj = qs.stringify(obj)
        return myPost({
            url: urls.add_city,
            data: obj
        })
    },
    add_industry(obj) {
        obj = qs.stringify(obj)
        return myPost({
            url: urls.add_industry,
            data: obj
        })
    },
    edit_city(obj) {
        obj = qs.stringify(obj)
        return myPost({
            url: urls.edit_city,
            data: obj
        })
    },
    edit_industry(obj) {
        obj = qs.stringify(obj)
        return myPost({
            url: urls.edit_industry,
            data: obj
        })
    },
    del_city(obj) {
        obj = qs.stringify(obj)
        return myPost({
            url: urls.del_city,
            data: obj
        })
    },
    del_industry(obj) {
        obj = qs.stringify(obj)
        return myPost({
            url: urls.del_industry,
            data: obj
        })
    },

    industry_zhilianlist(obj) {
        obj = qs.stringify(obj)
        return myPost({
            url: urls.industry_zhilianlist,
            data: obj
        })
    },
    add_industry_zhilian(obj) {
        obj = qs.stringify(obj)
        return myPost({
            url: urls.add_industry_zhilian,
            data: obj
        })
    },
    edit_industry_zhilian(obj) {
        obj = qs.stringify(obj)
        return myPost({
            url: urls.edit_industry_zhilian,
            data: obj
        })
    },
    del_industry_zhilian(obj) {
        obj = qs.stringify(obj)
        return myPost({
            url: urls.del_industry_zhilian,
            data: obj
        })
    },
    industrycity_zhilianlist(obj) {
        obj = qs.stringify(obj)
        return myPost({
            url: urls.industrycity_zhilianlist,
            data: obj
        })
    },
    del_industrycity_zhilian(obj) {
        obj = qs.stringify(obj)
        return myPost({
            url: urls.del_industrycity_zhilian,
            data: obj
        })
    },
    industrycity_list(obj) {
        obj = qs.stringify(obj)
        return myPost({
            url: urls.industrycity_list,
            data: obj
        })
    },
    del_industrycity(obj) {
        obj = qs.stringify(obj)
        return myPost({
            url: urls.del_industrycity,
            data: obj
        })
    },
    city_zhilian_tree(obj) {
        obj = qs.stringify(obj)
        return myPost({
            url: urls.city_zhilian_tree,
            data: obj
        })
    },
    industry_zhilian_tree(obj) {
        obj = qs.stringify(obj)
        return myPost({
            url: urls.industry_zhilian_tree,
            data: obj
        })
    },

    jobcategorylist(obj) {
        obj = qs.stringify(obj)
        return myPost({
            url: urls.jobcategorylist,
            data: obj
        })
    },
    jobcategory_tree(obj) {
        obj = qs.stringify(obj)
        return myGet({
            url: urls.jobcategory_tree+'?'+obj,
        })
    },
    add_jobcategory(obj) {
        obj = qs.stringify(obj)
        return myPost({
            url: urls.add_jobcategory,
            data: obj
        })
    },
    edit_jobcategory(obj) {
        obj = qs.stringify(obj)
        return myPost({
            url: urls.edit_jobcategory,
            data: obj
        })
    },
    del_jobcategory(obj) {
        obj = qs.stringify(obj)
        return myPost({
            url: urls.del_jobcategory,
            data: obj
        })
    },
    swiperlist(obj) {
        obj = qs.stringify(obj)
        return myPost({
            url: urls.swiperlist,
            data: obj
        })
    },
    add_swiper(obj) {
        obj = qs.stringify(obj)
        return myPost({
            url: urls.add_swiper,
            data: obj
        })
    },
    aliyun_osssts(obj) {
        obj = qs.stringify(obj)
        return myPost({
            url: urls.aliyun_osssts,
            data: obj
        })
    },
    aliyun_osssts2(obj) {
        obj = qs.stringify(obj)
        return myPost({
            url: urls.aliyun_osssts2,
            data: obj
        })
    },
    edit_swiper(obj) {
        obj = qs.stringify(obj)
        return myPost({
            url: urls.edit_swiper,
            data: obj
        })
    },
    del_swiper(obj) {
        obj = qs.stringify(obj)
        return myPost({
            url: urls.del_swiper,
            data: obj
        })
    },
    com_team(obj) {
        obj = qs.stringify(obj)
        return myPost({
            url: urls.com_team,
            data: obj
        })
    },
    compaylist(obj) {
        obj = qs.stringify(obj)
        return myPost({
            url: urls.compaylist,
            data: obj
        })
    },
    compayexaminelist(obj) {
        obj = qs.stringify(obj)
        return myPost({
            url: urls.compayexaminelist,
            data: obj
        })
    },
    compayexamineoperation(obj) {
        obj = qs.stringify(obj)
        return myPost({
            url: urls.compayexamineoperation,
            data: obj
        })
    },
    compayview(obj) {
        obj = qs.stringify(obj)
        return myPost({
            url: urls.compayview,
            data: obj
        })
    },
    compostlist(obj) {
        obj = qs.stringify(obj)
        return myPost({
            url: urls.compostlist,
            data: obj
        })
    },
    compostoperation(obj) {
        obj = qs.stringify(obj)
        return myPost({
            url: urls.compostoperation,
            data: obj
        })
    },
    compostcandidatelist(obj) {
        obj = qs.stringify(obj)
        return myPost({
            url: urls.compostcandidatelist,
            data: obj
        })
    },
    memberlist(obj) {
        obj = qs.stringify(obj)
        return myPost({
            url: urls.memberlist,
            data: obj
        })
    },
    del_member(obj) {
        obj = qs.stringify(obj)
        return myPost({
            url: urls.del_member,
            data: obj
        })
    },
    app_logo(obj) {
        obj = qs.stringify(obj)
        return myGet({
            url: urls.app_logo,
            data: obj
        })
    },
    editapp_logo(obj) {
        obj = qs.stringify(obj)
        return myPost({
            url: urls.app_logo,
            data: obj
        })
    },
    edupeizhi_viewmax(obj) {
        obj = qs.stringify(obj)
        return myGet({
            url: urls.edupeizhi_viewmax,
            data: obj
        })
    },
    editpeizhi_viewmax(obj) {
        obj = qs.stringify(obj)
        return myPost({
            url: urls.edupeizhi_viewmax,
            data: obj
        })
    },
    crudselectonebyid(obj) {
        obj = qs.stringify(obj)
        return myCrudGet({
            url: urls.crudselectonebyid+"?"+obj,
            // data: obj
        })
    },
    crudselectListByMap(obj) {
        obj = qs.stringify(obj)
        obj = qs.parse(obj, {depth: true})
        return myCrudPost({
            url: urls.crudselectListByMap,
            data: obj
        })
    },
    crudupdatebyid(obj) {
        obj = qs.stringify(obj)
        obj = qs.parse(obj, {depth: true})
        return myCrudPost({
            url: urls.crudupdatebyid,
            data: obj
        })
    },
    crudupdatebymap(obj) {
        obj = qs.stringify(obj)
        obj = qs.parse(obj, {depth: true})
        return myCrudPost({
            url: urls.crudupdatebymap,
            data: obj
        })
    },
    crudDeletebyid(obj) {
        obj = qs.stringify(obj)
        obj = qs.parse(obj, {depth: true})
        return myCrudPost({
            url: urls.crudDeletebyid,
            data: obj
        })
    },
    crudInsert(obj) {
        obj = qs.stringify(obj)
        obj = qs.parse(obj, {depth: true})
        return myCrudPost({
            url: urls.crudInsert,
            data: obj
        })
    },
    foreignlang_keyword(obj) {
        obj = qs.stringify(obj)
        return myGet({
            url: urls.foreignlang_keyword,
            data: obj
        })
    },
    editforeignlang_keyword(obj) {
        obj = qs.stringify(obj)
        return myPost({
            url: urls.foreignlang_keyword,
            data: obj
        })
    },
    post_rank(obj) {
        obj = qs.stringify(obj)
        return myGet({
            url: urls.post_rank,
            data: obj
        })
    },
    editpost_rank(obj) {
        obj = qs.stringify(obj)
        return myPost({
            url: urls.post_rank,
            data: obj
        })
    },
    vocabulary(obj) {
        obj = qs.stringify(obj)
        return myGet({
            url: urls.vocabulary,
            data: obj
        })
    },
    editvocabulary(obj) {
        obj = qs.stringify(obj)
        return myPost({
            url: urls.vocabulary,
            data: obj
        })
    },
    com_enterpriseagreement(obj) {
        obj = qs.stringify(obj)
        return myGet({
            url: urls.com_enterpriseagreement,
            data: obj
        })
    },
    editcom_enterpriseagreement(obj) {
        obj = qs.stringify(obj)
        return myPost({
            url: urls.com_enterpriseagreement,
            data: obj
        })
    },
    com_jobsagreement(obj) {
        obj = qs.stringify(obj)
        return myGet({
            url: urls.com_jobsagreement,
            data: obj
        })
    },
    editcom_jobsagreement(obj) {
        obj = qs.stringify(obj)
        return myPost({
            url: urls.com_jobsagreement,
            data: obj
        })
    },
    problemlist(obj) {
        obj = qs.stringify(obj)
        return myPost({
            url: urls.problemlist,
            data: obj
        })
    },
    add_problem(obj) {
        obj = qs.stringify(obj)
        return myPost({
            url: urls.add_problem,
            data: obj
        })
    },
    edit_problem(obj) {
        obj = qs.stringify(obj)
        return myPost({
            url: urls.edit_problem,
            data: obj
        })
    },
    del_problem(obj) {
        obj = qs.stringify(obj)
        return myPost({
            url: urls.del_problem,
            data: obj
        })
    },
    compostnavigation_view(obj) {
        obj = qs.stringify(obj)
        return myPost({
            url: urls.compostnavigation_view,
            data: obj
        })
    },
    problem_positionlist(obj) {
        obj = qs.stringify(obj)
        return myPost({
            url: urls.problem_positionlist,
            data: obj
        })
    },
    modify_userpass(obj) {
        obj = qs.stringify(obj)
        return myPost({
            url: urls.modify_userpass,
            data: obj
        })
    },
    async productUpload(image) {
        var configs = {
            headers: {
                "Content-Type": "multipart/form-data;charse=UTF-8",
                'token': `${sessionStorage.getItem("token")}`,
            },
        };
        const res = await axios
            .post(`${urls.baseUrl}/admin/upload_product_pic`, image, configs)
        return `${urls.baseUrl}/${res.data.data.path}`
    },
    async upload_pic(image) {
        var configs = {
            headers: {
                "Content-Type": "multipart/form-data;charse=UTF-8",
                'Authorization': `Bearer ${sessionStorage.getItem("token")}`,
            },
        };
        const res = await axios
            .post(`${urls.baseUrl}/admin/upload_pic`, image, configs)
        return res.data
    },
    modellist(obj) {
        obj = qs.stringify(obj)
        return myPost({
            url: urls.modellist,
            data: obj
        })
    },
    modelresultlist(obj) {
        obj = qs.stringify(obj)
        return myPost({
            url: urls.modelresultlist,
            data: obj
        })
    },
    add_modelresult(obj) {
        obj = qs.stringify(obj)
        return myPost({
            url: urls.add_modelresult,
            data: obj
        })
    },
    edit_modelresult(obj) {
        obj = qs.stringify(obj)
        return myPost({
            url: urls.edit_modelresult,
            data: obj
        })
    },
    del_modelresult(obj) {
        obj = qs.stringify(obj)
        return myPost({
            url: urls.del_modelresult,
            data: obj
        })
    },
    modelcheck(obj) {
        obj = qs.stringify(obj)
        return myPost({
            url: urls.modelcheck,
            data: obj
        })
    },
    modellistlist(obj) {
        obj = qs.stringify(obj)
        return myPost({
            url: urls.modellistlist,
            data: obj
        })
    },
    modellistcheck(obj) {
        obj = qs.stringify(obj)
        return myPost({
            url: urls.modellistcheck,
            data: obj
        })
    },
    zuhelist(obj) {
        obj = qs.stringify(obj)
        return myPost({
            url: urls.zuhelist,
            data: obj
        })
    },
    gslist(obj) {
        obj = qs.stringify(obj)
        return myPost({
            url: urls.gslist,
            data: obj
        })
    },gslist0(obj) {
        obj = qs.stringify(obj)
        return myPost({
            url: urls.gslist0,
            data: obj
        })
    },
    gsindustrys(obj) {
        obj = qs.stringify(obj)
        return myPost({
            url: urls.gsindustrys,
            data: obj
        })
    },
    add_gs(obj) {
        obj = qs.stringify(obj)
        return myPost({
            url: urls.add_gs,
            data: obj
        })
    },
    edit_gs(obj) {
        obj = qs.stringify(obj)
        return myPost({
            url: urls.edit_gs,
            data: obj
        })
    },
    del_gs(obj) {
        obj = qs.stringify(obj)
        return myPost({
            url: urls.del_gs,
            data: obj
        })
    },
    del_gs2(obj) {
        obj = qs.stringify(obj)
        return myPost({
            url: urls.del_gs2,
            data: obj
        })
    },
    memorytable(obj){
        return myGet({
                url: urls.memorytable,
                params: {
                    ...obj
                }
            }
        )
    },
    user_candidateview(obj) {
        obj = qs.stringify(obj)
        return myPost({
            url: urls.user_candidateview,
            data: obj
        })
    },
    edit_user_joincompany(obj) {
        obj = qs.stringify(obj)
        return myPost({
            url: urls.edit_user_joincompany,
            data: obj
        })
    },
    import_excel(obj) {
        return myPost2({
            url: urls.import_excel,
            data: obj
        })
    },
    upload_url(){
        return urls.baseUrl+urls.upload;
    },
    hirebotuser_add(obj) {
        obj = qs.stringify(obj)
        return myPost({
            url: urls.hirebotuser_add,
            data: obj
        })
    },
    hirebotuser_update(obj) {
        obj = qs.stringify(obj)
        return myPost({
            url: urls.hirebotuser_update,
            data: obj
        })
    },
    hirebotuser_resetpass(obj) {
        obj = qs.stringify(obj)
        return myPost({
            url: urls.hirebotuser_resetpass,
            data: obj
        })
    },
    hirebotuser_recharge_balance(obj) {
        obj = qs.stringify(obj)
        return myPost({
            url: urls.hirebotuser_recharge_balance,
            data: obj
        })
    },
    hirebotuser_refund_balance(obj) {
        obj = qs.stringify(obj)
        return myPost({
            url: urls.hirebotuser_refund_balance,
            data: obj
        })
    },
    hirebotuser_adjust_balance(obj) {
        obj = qs.stringify(obj)
        return myPost({
            url: urls.hirebotuser_adjust_balance,
            data: obj
        })
    },
    hirebotuser_balance_logs(obj) {
        return myGet({
            url: urls.hirebotuser_balance_logs,
            params: obj
        })
    },
    hirebotuser_list(obj) {
        obj = qs.stringify(obj)
        return myGet({
            url: urls.hirebotuser_list,
            params: {
                ...obj
            }
        })
    },
    hirebotuser_postslist(obj) {
        return myGet({
            url: urls.hirebotuser_postslist,
            params: obj
        })
    },
    hirebotuser_my_scope_users(obj) {
        return myGet({
            url: urls.hirebotuser_my_scope_users,
            params: obj
        })
    },
    aimodelconfig_check(obj) {
        obj = qs.stringify(obj)
        return myPost({
            url: urls.aimodelconfig_check,
            data: obj
        })
    },
    
    // ========== 院校分类API方法 ========== //
    school_list(obj) {
        obj = qs.stringify(obj)
        return myPost({
            url: urls.school_list,
            data: obj
        })
    },
    school_add(obj) {
        obj = qs.stringify(obj)
        return myPost({
            url: urls.school_add,
            data: obj
        })
    },
    school_edit(obj) {
        obj = qs.stringify(obj)
        return myPost({
            url: urls.school_edit,
            data: obj
        })
    },
    school_delete(obj) {
        obj = qs.stringify(obj)
        return myPost({
            url: urls.school_delete,
            data: obj
        })
    },
    school_typeList(obj) {
        obj = qs.stringify(obj)
        return myPost({
            url: urls.school_typeList,
            data: obj
        })
    },
    // ==================================== //
}
